<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <router-link
            :to="`/app/administration/tefConfig`"
          >
            <v-icon
              class="mr-2"
              color="red darken-2"
              right
            >
              mdi-arrow-left-bold
            </v-icon>
          </router-link>
          Bines [ {{ this.$route.query.Client }}]
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          />
          <v-spacer />
        </v-card-title>
        <br>
        <v-alert
          v-show="deleteBinAlertStatus === false"
          type="success"
          text
        >
          {{ msgBinDeleted }}
        </v-alert>
        <v-alert
          v-show="deleteBinAlertStatus === true"
          type="warning"
          text
        >
          {{ msgBinNotDeleted }}
        </v-alert>
        <br>
        <v-card-text>
          <v-data-table
            :footer-props="{
              'items-per-page-text': 'filas por pagina',
            }"
            :headers="headers"
            :items="getListBines"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.Eliminar`]="{ item }">
              <v-icon
                style="cursor:pointer;text-align-last: center;"
                color="red darken-3"
                class="mr-2"
                @click="openDialog(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-h5">
          Confirmar eliminación
        </v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar el BIN: {{ selectedItem ? selectedItem.bin : '' }} ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            style="background-color:rgb(204 33 40);color:white !important"
            @click="confirmDelete"
          >
            Eliminar
          </v-btn>
          <v-btn @click="closeDialog">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex'
  import item from '../../../../components/base/item.vue'

  export default {

    name: 'ShowBinesTef',
    data () {
      return {
        search: '',
        dialog: false,
        selectedItem: null,
        deleteBinAlertStatus: null,
        msgBinDeleted: 'BIN eliminado correctamente',
        msgBinNotDeleted: 'El BIN no pudo ser eliminado',
        headers: [
          {
            text: 'BIN',
            value: 'bin',
          },
          {
            text: 'Id Red Adquirente',
            value: 'acquirer_network_id',
            align: 'center',
          },
          {
            text: 'Red Adquirente',
            value: 'acquirer_network',
          },
          {
            text: 'Banco',
            value: 'bank',
            align: 'center',

          },
          {
            text: 'Eliminar',
            value: 'Eliminar',
            align: 'center',

          },
        ],
      }
    },
    computed: {
      item () {
        return item
      },
      ...mapState('credentialsTef', [
        'listBines',
      ]),

      getListBines () {
        return this.$store.state.credentialsTef.listBines
      },
      updateResponseDeleteBin () {
        return this.$store.state.credentialsTef.statusDeleteBinResponse
      },

    },
    watch: {
      updateResponseDeleteBin () {
        if (this.updateResponseDeleteBin !== null) {
          this.deleteBinAlertStatus = this.updateResponseDeleteBin
          this.generateBinDeletedAlert()
          this.$store.dispatch('credentialsTef/setUpdateResponseDeleteBin', null)
        }
      },
    },
    created () {
      this.getListTerminales()
    },
    methods: {
      openDialog (item) {
        this.selectedItem = item
        this.dialog = true
      },
      closeDialog () {
        this.dialog = false
        this.selectedItem = null
      },
      confirmDelete () {
        this.deleteBin(this.selectedItem)
        this.closeDialog()
      },
      generateBinDeletedAlert () {
        this.$store.dispatch('credentialsTef/getListBines', this.$route.query)
        setTimeout(() => {
          this.deleteBinAlertStatus = null
        }, 3000,
        )
      },
      async getListTerminales () {
        await this.$store.dispatch('credentialsTef/getListBines', this.$route.query)
      },

      async deleteBin (item) {
        await this.$store.dispatch('credentialsTef/deleteBin', item)
      },
    },
  }
</script>
